import React from "react";
import "./ChartTabStrip.scss";

const PILL_INSET_V = 4;
const PILL_INSET_H = 6;

/*
 * Tab-bar variant of src/components/CenterSnapStrip for the dashboard chart
 * toggles: same pill-behind-selected-label look, but a plain click-to-switch
 * tablist instead of the scroll-snap carousel. Every option is always visible,
 * so widths come from flex + percentages rather than a measured container.
 */
const ChartTabStrip = ({
  labels,
  selectedIndex,
  onSelect,
  backgroundColor,
  textColor,
  accessibilityLabels,
  selectedTabColor,
  selectedTextColor,
}) => {
  const count = labels.length;

  if (!count) return null;

  const pillWidthPct = 100 / count;

  return (
    <div className="chart-tab-strip" style={{ backgroundColor }}>
      <div
        className="chart-tab-strip__pill"
        style={{
          left: `calc(${selectedIndex * pillWidthPct}% + ${PILL_INSET_H}px)`,
          width: `calc(${pillWidthPct}% - ${PILL_INSET_H * 2}px)`,
          top: PILL_INSET_V,
          bottom: PILL_INSET_V,
          backgroundColor: selectedTabColor || "#ffffff",
        }}
      />

      <div className="chart-tab-strip__tabs" role="tablist">
        {labels.map((label, index) => {
          const isSelected = index === selectedIndex;

          return (
            <button
              key={`${index}-${label}`}
              type="button"
              className="chart-tab-strip__tab"
              role="tab"
              onClick={() => index !== selectedIndex && onSelect(index)}
              aria-label={accessibilityLabels?.[index] || label}
              aria-selected={isSelected}
            >
              <span
                className="chart-tab-strip__text"
                style={{ color: isSelected ? selectedTextColor : textColor }}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ChartTabStrip;
